import React from 'react';
import type { SectionWithLessons } from '../types';

interface ContentOverviewProps {
  sections: SectionWithLessons[];
}

const ContentOverview: React.FC<ContentOverviewProps> = ({ sections }) => {
  if (sections.length === 0) return null;

  const totalLessons = sections.reduce((sum, s) => sum + s.lessons.length, 0);

  return (
    <div style={{
      backgroundColor: '#f8f9fa',
      padding: '15px 20px',
      borderRadius: '8px',
      marginBottom: '20px',
      border: '1px solid #e0e0e0',
    }}>
      <h3 style={{ fontSize: '16px', marginBottom: '10px', color: '#333' }}>
        Course Content Overview
      </h3>
      <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
        Total Sections: <strong>{sections.length}</strong> |{' '}
        Total Lessons: <strong>{totalLessons}</strong>
      </p>
    </div>
  );
};

export default React.memo(ContentOverview);
